export default "__VITE_ASSET__BgJJGrXa__"